import React from 'react';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { useActiveRecordDocuments, useArchivedRecordDocuments, useRecordDocumentRequirements } from '../../../../../../../../services/record-service';
import InsuredSectionDropdown from '../InsuredSectionDropdown';

import DocumentIconTray from './components/DocumentIconTray';
import DocumentsTableContainer from './components/DocumentsTableContainer';

const DocumentRequirements = ({ companyId, insuredId, recordId, jobId }) => {
  const { isFetching: documentRequirementsFetching } = useRecordDocumentRequirements(recordId);
  const { isFetching: documentsFetching } = useActiveRecordDocuments({ recordId });
  useArchivedRecordDocuments({ recordId });

  return (
    <InsuredSectionDropdown
      openByDefault
      icons={<DocumentIconTray companyId={companyId} insuredId={insuredId} jobId={jobId} recordId={recordId} />}
      isFetching={documentRequirementsFetching || documentsFetching}
      title="Required Documents"
    >
      <Flex alignItems="center" bg="white" justifyContent="center">
        <DocumentsTableContainer insuredId={insuredId} jobId={jobId} recordId={recordId} />
      </Flex>
    </InsuredSectionDropdown>
  );
};

DocumentRequirements.propTypes = {
  companyId: PropTypes.number.isRequired,
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired
};

export default DocumentRequirements;
